import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState } from '../../reducers/auth/auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated,
);

export const selectAuthCheckCompleted = createSelector(
  selectAuthState,
  (state: AuthState) => state.authCheckCompleted,
);
